// 本模块用来调用新闻接口与相关逻辑处理
import axios from "axios";
export default {
  news(data) {
    return axios({
      url: "/api/news",
      method: "get",
      params: {
        per_page: data.per_page,
        page: data.page,
        category_id: data.category_id
      }
    });
  },
  newCategory() {
    return axios({
      url: "/api/new-category",
      method: "get",
      params: {}
    });
  },
  newsDetails(id) {
    return axios({
      url: "/api/news/" + id,
      method: "get",
      params: {}
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/news.js